import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=2793e76a&scoped=true"
import script from "./ItemSelector.vue?vue&type=script&lang=js"
export * from "./ItemSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2793e76a",
  null
  
)

export default component.exports